import { cva } from "class-variance-authority";

const stylesBg = cva(
  "invisible absolute top-[64px] group-hover:visible items-center right-0 flex flex-col flex-nowrap shadow-lg rounded-[8px] p-[24px]",
  {
    variants: {
      mode: {
        light: "bg-light-background",
        dark: "bg-dark-background"
      }
    }
  }
);

const stylesButton = cva(
  "flex items-center bg-gray  w-[183px] mb-[20px] px-[16px] py-[7px] rounded-[4px]",
  {
    variants: {
      mode: {
        light: "bg-light-fill-secondary",
        dark: "bg-dark-fill-secondary"
      }
    }
  }
);

export { stylesBg, stylesButton };
